import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-stop.svg";
import * as styles from "./Icon.module.scss";

type StopProps = React.SVGProps<SVGSVGElement>;

export const Stop = ({ className, ...props }: StopProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
